module.exports = __webpack_public_path__ + "static/stb_message-structure@2x-49acc33fdd7cbadff3e624f4e21204b4.jpg";